import React, { useContext, useEffect } from 'react'
import { ConnectorViewMappingContext } from './context/context'
import ConnectorMappingForm from './ConnectorMappingForm'
import ConnectorImage from './ConnectorImage'
import { NavContext } from '../../../context/global_context'
import { useParams } from 'react-router-dom'
import { getRequest } from '../../../services/base'
import { getRandomString } from '../../../utils/common'

const ConnectorMapping = (props) => {
  const { vehicle, connector_view } = useParams()
  const [state, dispatch] = useContext(ConnectorViewMappingContext)
  const [navState, navDispatch] = useContext(NavContext)

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: vehicle,
        sub_header: 'Vehicle View Connector Mapping',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        back_btn_url: `/vehicles/${vehicle}/connector_views/`,
        full_width_container: true,
      },
    })
    getConnectorViewData()
  }, [])

  const getConnectorViewData = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Connector Views Data',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(`/api/connector_views/${connector_view}/`)
    if (res?.is_locked) {
      checkUploadStatus()
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Upload In Progress, You can`t do any operations',
          showLoader: true,
        },
        notification: {},
      })
    } else {
      dispatch({
        type: 'connector_view',
        data: { ...res, svg: `${res?.svg}?string=${getRandomString()}` },
      })
      navDispatch({
        type: 'loader',
        data: {
          caption: '',
          showLoader: false,
        },
        notification: {},
      })
    }
  }

  const checkUploadStatus = async () => {
    let res = await getRequest(
      `/api/connector_views/upload_status/${connector_view}/`
    )
    if (res?.data === true && res?.status) {
      setTimeout(() => {
        checkUploadStatus()
      }, 1500)
    } else {
      getConnectorViewData()
    }
  }

  return (
    <div
      className="flex flex-grow stretch-items overflow-hidden"
      style={{ height: 'calc(100vh - 64px)' }}
    >
      <ConnectorMappingForm />
      <ConnectorImage />
    </div>
  )
}

ConnectorMapping.propTypes = {}

export default ConnectorMapping
